import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import Panel from '../../../Panels';
import { SafetyAllianceSearchObject } from '../../../../types/report';
import { dateIfDate } from '../lib/formatting';

interface Props {
  search: SafetyAllianceSearchObject;
}

const SafetyAllianceSearch = ({ search }: Props): React.ReactElement | null => {
  if (!search || search.status === 'canceled') return null;
  if (!search.incidents || search.incidents.length === 0) return null;

  return (
    <Panel
      data-testid='safety-alliance-search'
      title={i18n.getStr('components.safetyAllianceSearch.title')}
      status={search.result ?? undefined}
    >
      <p className='text-muted mb-3'>
        {i18n.getStr('components.safetyAllianceSearch.description')}
      </p>
      {search.incidents.map(incident => (
        <div key={incident.incidentId} className='mb-2'>
          <hr className='mb-2 mt-2' />
          <div className='d-flex justify-content-between'>
            <span>{incident.category}</span>
            <span className='text-muted'>
              {incident.incidentDate ? dateIfDate(incident.incidentDate) : null}
            </span>
          </div>
        </div>
      ))}
    </Panel>
  );
};

export default i18n.renderTranslation()(SafetyAllianceSearch);
